import styled from 'styled-components';

import Media from '../../../assets/styles/media';
import THEME from '../../../assets/styles/config';

import img from '../../../assets/images/header-image.jpg';

export const AngledBackground = styled.svg`
  height: 100%;
  width: 60%;
  min-width: 800px;
  max-width: 990px;
  overflow: hidden;

  ${Media.Below.mobileLarge`
    min-width: 130%;
  `}
`;

export const Background = styled.div`
  z-index: -2;
  background: url(${props => `${props.image}`}) no-repeat;
  background-position: right center;
  background-size: auto 100%;
  background-color: black;
  height: 100vh;
  min-height: 750px;
  width: 100vw;
  display: flex;
  align-items: center;
  overflow-x: hidden;

  ${Media.Below.tablet`
    min-height: 700px;
  `}

  ${Media.Below.mobileLarge`
    min-height: 560px;
    background-position: center top;
    background-size: contain;
    flex-direction: column;
    align-items: flex-start;
  `}
`;

export const ContentCtn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  width: 540px;
  background-color: ${THEME.colors.primaryBackgroundColor};
  z-index: 1;
  margin: 0 -1px;

  ${Media.Below.mobileLarge`
    justify-content: flex-start;
    padding: 0 3vw;
    margin: -1px 0 0;
    width: 100%;
    order: 2;
    padding-bottom: 20px;
  `}
`;

export const LogoImgCtn = styled.div`
  height: 49px;
  margin-top: 4vh;
  margin-bottom: 40px;

  ${Media.Below.tablet`
    height: 40px;
    margin-bottom: 20px;
  `}

  ${Media.Below.mobileLarge`
    height: 35px;
    margin-bottom: 5px;
  `}
`;

export const LogoutBtn = styled.button`
  color: ${THEME.colors.primaryFontColor};
  font-size: 18px;
  text-align: start;
  background-color: transparent;
  cursor: pointer;
`;

export const PageHeader = styled.p`
  font-size: 18px;

  ${Media.Below.tablet`
    font-size: 14px;
  `}
  
  
`;

export const SelectContractPage = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  z-index: 100;
`;

export const GreetingHeader = styled.p`
  font-size: 24px;
  font-weight: bolder;
  
  ${Media.Below.tablet`
    font-size: 20px;
  `}
`;
